import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center w-100 py-5 text-muted",
  style: {"min-height":"40vh"},
  role: "status",
  "aria-live": "polite"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.is_show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("i", {
          class: "fas fa-spinner fa-spin fa-2x",
          "aria-hidden": "true"
        }, null, -1),
        _createElementVNode("span", { class: "mt-3 small" }, "Cargando…", -1)
      ]))]))
    : _createCommentVNode("", true)
}